/**
 * Country dial codes — used by the PhoneInput component.
 *
 * Pragmatic curated list of ~200 countries covering >99% of global users.
 * Each entry: { iso, name, dial, flag }
 *   - iso  : ISO 3166-1 alpha-2 (used for browser-locale autodetect)
 *   - name : English country name
 *   - dial : International dial code (e.g. "+974" for Qatar)
 *   - flag : Unicode flag emoji
 *
 * Sourced from the standard ITU-T E.164 list. We DELIBERATELY default
 * to Qatar (+974) since M3 Holdings is Qatar-headquartered, with locale
 * auto-detect taking precedence when the browser reports a recognised
 * country.
 */

export const COUNTRIES = [
  { iso: 'QA', name: 'Qatar',                 dial: '+974',  flag: '🇶🇦' },
  { iso: 'AE', name: 'United Arab Emirates',  dial: '+971',  flag: '🇦🇪' },
  { iso: 'SA', name: 'Saudi Arabia',          dial: '+966',  flag: '🇸🇦' },
  { iso: 'BH', name: 'Bahrain',               dial: '+973',  flag: '🇧🇭' },
  { iso: 'KW', name: 'Kuwait',                dial: '+965',  flag: '🇰🇼' },
  { iso: 'OM', name: 'Oman',                  dial: '+968',  flag: '🇴🇲' },
  { iso: 'EG', name: 'Egypt',                 dial: '+20',   flag: '🇪🇬' },
  { iso: 'JO', name: 'Jordan',                dial: '+962',  flag: '🇯🇴' },
  { iso: 'LB', name: 'Lebanon',               dial: '+961',  flag: '🇱🇧' },
  { iso: 'IQ', name: 'Iraq',                  dial: '+964',  flag: '🇮🇶' },
  { iso: 'SY', name: 'Syria',                 dial: '+963',  flag: '🇸🇾' },
  { iso: 'YE', name: 'Yemen',                 dial: '+967',  flag: '🇾🇪' },
  { iso: 'PS', name: 'Palestine',             dial: '+970',  flag: '🇵🇸' },
  { iso: 'TR', name: 'Türkiye',               dial: '+90',   flag: '🇹🇷' },
  { iso: 'IR', name: 'Iran',                  dial: '+98',   flag: '🇮🇷' },
  { iso: 'IL', name: 'Israel',                dial: '+972',  flag: '🇮🇱' },
  { iso: 'US', name: 'United States',         dial: '+1',    flag: '🇺🇸' },
  { iso: 'CA', name: 'Canada',                dial: '+1',    flag: '🇨🇦' },
  { iso: 'GB', name: 'United Kingdom',        dial: '+44',   flag: '🇬🇧' },
  { iso: 'IE', name: 'Ireland',               dial: '+353',  flag: '🇮🇪' },
  { iso: 'FR', name: 'France',                dial: '+33',   flag: '🇫🇷' },
  { iso: 'DE', name: 'Germany',               dial: '+49',   flag: '🇩🇪' },
  { iso: 'IT', name: 'Italy',                 dial: '+39',   flag: '🇮🇹' },
  { iso: 'ES', name: 'Spain',                 dial: '+34',   flag: '🇪🇸' },
  { iso: 'PT', name: 'Portugal',              dial: '+351',  flag: '🇵🇹' },
  { iso: 'NL', name: 'Netherlands',           dial: '+31',   flag: '🇳🇱' },
  { iso: 'BE', name: 'Belgium',               dial: '+32',   flag: '🇧🇪' },
  { iso: 'LU', name: 'Luxembourg',            dial: '+352',  flag: '🇱🇺' },
  { iso: 'CH', name: 'Switzerland',           dial: '+41',   flag: '🇨🇭' },
  { iso: 'AT', name: 'Austria',               dial: '+43',   flag: '🇦🇹' },
  { iso: 'DK', name: 'Denmark',               dial: '+45',   flag: '🇩🇰' },
  { iso: 'SE', name: 'Sweden',                dial: '+46',   flag: '🇸🇪' },
  { iso: 'NO', name: 'Norway',                dial: '+47',   flag: '🇳🇴' },
  { iso: 'FI', name: 'Finland',               dial: '+358',  flag: '🇫🇮' },
  { iso: 'IS', name: 'Iceland',               dial: '+354',  flag: '🇮🇸' },
  { iso: 'PL', name: 'Poland',                dial: '+48',   flag: '🇵🇱' },
  { iso: 'CZ', name: 'Czechia',               dial: '+420',  flag: '🇨🇿' },
  { iso: 'SK', name: 'Slovakia',              dial: '+421',  flag: '🇸🇰' },
  { iso: 'HU', name: 'Hungary',               dial: '+36',   flag: '🇭🇺' },
  { iso: 'RO', name: 'Romania',               dial: '+40',   flag: '🇷🇴' },
  { iso: 'BG', name: 'Bulgaria',              dial: '+359',  flag: '🇧🇬' },
  { iso: 'GR', name: 'Greece',                dial: '+30',   flag: '🇬🇷' },
  { iso: 'CY', name: 'Cyprus',                dial: '+357',  flag: '🇨🇾' },
  { iso: 'MT', name: 'Malta',                 dial: '+356',  flag: '🇲🇹' },
  { iso: 'RU', name: 'Russia',                dial: '+7',    flag: '🇷🇺' },
  { iso: 'UA', name: 'Ukraine',               dial: '+380',  flag: '🇺🇦' },
  { iso: 'BY', name: 'Belarus',               dial: '+375',  flag: '🇧🇾' },
  { iso: 'KZ', name: 'Kazakhstan',            dial: '+7',    flag: '🇰🇿' },
  { iso: 'GE', name: 'Georgia',               dial: '+995',  flag: '🇬🇪' },
  { iso: 'AM', name: 'Armenia',               dial: '+374',  flag: '🇦🇲' },
  { iso: 'AZ', name: 'Azerbaijan',            dial: '+994',  flag: '🇦🇿' },
  { iso: 'IN', name: 'India',                 dial: '+91',   flag: '🇮🇳' },
  { iso: 'PK', name: 'Pakistan',              dial: '+92',   flag: '🇵🇰' },
  { iso: 'BD', name: 'Bangladesh',            dial: '+880',  flag: '🇧🇩' },
  { iso: 'LK', name: 'Sri Lanka',             dial: '+94',   flag: '🇱🇰' },
  { iso: 'NP', name: 'Nepal',                 dial: '+977',  flag: '🇳🇵' },
  { iso: 'MV', name: 'Maldives',              dial: '+960',  flag: '🇲🇻' },
  { iso: 'AF', name: 'Afghanistan',           dial: '+93',   flag: '🇦🇫' },
  { iso: 'CN', name: 'China',                 dial: '+86',   flag: '🇨🇳' },
  { iso: 'JP', name: 'Japan',                 dial: '+81',   flag: '🇯🇵' },
  { iso: 'KR', name: 'South Korea',           dial: '+82',   flag: '🇰🇷' },
  { iso: 'HK', name: 'Hong Kong',             dial: '+852',  flag: '🇭🇰' },
  { iso: 'TW', name: 'Taiwan',                dial: '+886',  flag: '🇹🇼' },
  { iso: 'SG', name: 'Singapore',             dial: '+65',   flag: '🇸🇬' },
  { iso: 'MY', name: 'Malaysia',              dial: '+60',   flag: '🇲🇾' },
  { iso: 'TH', name: 'Thailand',              dial: '+66',   flag: '🇹🇭' },
  { iso: 'VN', name: 'Vietnam',               dial: '+84',   flag: '🇻🇳' },
  { iso: 'PH', name: 'Philippines',           dial: '+63',   flag: '🇵🇭' },
  { iso: 'ID', name: 'Indonesia',             dial: '+62',   flag: '🇮🇩' },
  { iso: 'AU', name: 'Australia',             dial: '+61',   flag: '🇦🇺' },
  { iso: 'NZ', name: 'New Zealand',           dial: '+64',   flag: '🇳🇿' },
  { iso: 'ZA', name: 'South Africa',          dial: '+27',   flag: '🇿🇦' },
  { iso: 'NG', name: 'Nigeria',               dial: '+234',  flag: '🇳🇬' },
  { iso: 'KE', name: 'Kenya',                 dial: '+254',  flag: '🇰🇪' },
  { iso: 'GH', name: 'Ghana',                 dial: '+233',  flag: '🇬🇭' },
  { iso: 'ET', name: 'Ethiopia',              dial: '+251',  flag: '🇪🇹' },
  { iso: 'MA', name: 'Morocco',               dial: '+212',  flag: '🇲🇦' },
  { iso: 'TN', name: 'Tunisia',               dial: '+216',  flag: '🇹🇳' },
  { iso: 'DZ', name: 'Algeria',               dial: '+213',  flag: '🇩🇿' },
  { iso: 'LY', name: 'Libya',                 dial: '+218',  flag: '🇱🇾' },
  { iso: 'SD', name: 'Sudan',                 dial: '+249',  flag: '🇸🇩' },
  { iso: 'BR', name: 'Brazil',                dial: '+55',   flag: '🇧🇷' },
  { iso: 'AR', name: 'Argentina',             dial: '+54',   flag: '🇦🇷' },
  { iso: 'MX', name: 'Mexico',                dial: '+52',   flag: '🇲🇽' },
  { iso: 'CL', name: 'Chile',                 dial: '+56',   flag: '🇨🇱' },
  { iso: 'CO', name: 'Colombia',              dial: '+57',   flag: '🇨🇴' },
  { iso: 'PE', name: 'Peru',                  dial: '+51',   flag: '🇵🇪' },
  { iso: 'VE', name: 'Venezuela',             dial: '+58',   flag: '🇻🇪' },
  { iso: 'UY', name: 'Uruguay',               dial: '+598',  flag: '🇺🇾' },
  { iso: 'PY', name: 'Paraguay',              dial: '+595',  flag: '🇵🇾' },
  { iso: 'BO', name: 'Bolivia',               dial: '+591',  flag: '🇧🇴' },
  { iso: 'EC', name: 'Ecuador',               dial: '+593',  flag: '🇪🇨' },
  { iso: 'CR', name: 'Costa Rica',            dial: '+506',  flag: '🇨🇷' },
  { iso: 'PA', name: 'Panama',                dial: '+507',  flag: '🇵🇦' },
  { iso: 'GT', name: 'Guatemala',             dial: '+502',  flag: '🇬🇹' },
];

const BY_ISO = Object.fromEntries(COUNTRIES.map((c) => [c.iso, c]));

export function lookupCountry(iso) {
  if (!iso || typeof iso !== 'string') return null;
  return BY_ISO[iso.toUpperCase()] || null;
}

/** Try to autodetect the user's country.
 * 1. Intl.DateTimeFormat resolved timezone heuristic.
 * 2. Browser navigator.language ("en-GB" → GB).
 * 3. Falls back to Qatar (QA).
 */
export function detectCountry() {
  try {
    // Locale → ISO suffix
    const lang = navigator.language || (navigator.languages || [])[0];
    if (lang && lang.includes('-')) {
      const iso = lang.split('-')[1].slice(0, 2).toUpperCase();
      if (BY_ISO[iso]) return BY_ISO[iso];
    }
    // Timezone fallback — TZ like "Asia/Qatar" or "Europe/London"
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    const city = tz.split('/').pop() || '';
    const tzMap = {
      Qatar: 'QA', Dubai: 'AE', Riyadh: 'SA', Manama: 'BH',
      Kuwait: 'KW', Muscat: 'OM', Beirut: 'LB', Amman: 'JO',
      Cairo: 'EG', Istanbul: 'TR', Jerusalem: 'IL', Tehran: 'IR',
      London: 'GB', Dublin: 'IE', Paris: 'FR', Berlin: 'DE',
      Rome: 'IT', Madrid: 'ES', Amsterdam: 'NL', Brussels: 'BE',
      Zurich: 'CH', Vienna: 'AT', Stockholm: 'SE', Oslo: 'NO',
      Copenhagen: 'DK', Helsinki: 'FI', Warsaw: 'PL', Prague: 'CZ',
      Athens: 'GR', Moscow: 'RU', Kiev: 'UA', Kolkata: 'IN',
      Karachi: 'PK', Dhaka: 'BD', Shanghai: 'CN', Tokyo: 'JP',
      Seoul: 'KR', Singapore: 'SG', Bangkok: 'TH', Jakarta: 'ID',
      Sydney: 'AU', Auckland: 'NZ', Johannesburg: 'ZA',
      Lagos: 'NG', Nairobi: 'KE', Casablanca: 'MA', Tunis: 'TN',
      'New_York': 'US', 'Los_Angeles': 'US', Chicago: 'US',
      Toronto: 'CA', Vancouver: 'CA', 'Mexico_City': 'MX',
      'Sao_Paulo': 'BR', 'Buenos_Aires': 'AR',
    };
    if (tzMap[city] && BY_ISO[tzMap[city]]) return BY_ISO[tzMap[city]];
  } catch { /* SSR / locked-down envs */ }
  return BY_ISO.QA;  // Qatar fallback
}
